import React from 'react';
import { motion } from 'framer-motion';
import { Code2, Megaphone, Mail } from 'lucide-react';
import Navbar from '../components/common/Navbar';
import '../styles/pages/Careers.scss';

const CAREERS = [
    {
        title: 'Full Stack Developer',
        icon: Code2,
        color: '#4f7c67',
        description: 'We are getting ready to grow our engineering team for new modules and platform improvements. This role is not open yet so please check back soon.',
    },
    {
        title: 'Digital Marketing and Content Manager',
        icon: Megaphone,
        color: '#c2762a',
        description: 'Once our platform reaches full scale we will look for a teammate to lead our social presence and content strategy. This role will open once we share the announcement.',
    },
];

const Careers = () => {
    return (
        <div className="careers-wrapper">
            <Navbar />

            <section className="careers-hero">
                <motion.div
                    className="careers-hero-text"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, ease: 'easeOut' }}
                >
                    <p className="careers-breadcrumb">YeniDers &bull; Careers</p>
                    <h1>Careers</h1>
                    <p className="careers-subtitle">
                        We are a small team building something we believe in. These are the roles
                        we expect to open next.
                    </p>
                </motion.div>
            </section>

            <section className="careers-grid-section">
                <div className="careers-grid">
                    {CAREERS.map((job, index) => {
                        const Icon = job.icon;
                        return (
                            <motion.div
                                key={job.title}
                                className="career-card"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6, delay: index * 0.15, ease: 'easeOut' }}
                            >
                                <div className="career-top">
                                    <div className="career-icon-circle" style={{ background: `${job.color}1a`, color: job.color }}>
                                        <Icon size={22} strokeWidth={2} />
                                    </div>
                                    <span className="career-status">Coming Soon</span>
                                </div>
                                <h3>{job.title}</h3>
                                <p>{job.description}</p>
                            </motion.div>
                        );
                    })}
                </div>

                <motion.a
                    href="mailto:support@yeniders.com?subject=Career%20Interest%20at%20YeniDers"
                    className="careers-cta"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.3, ease: 'easeOut' }}
                >
                    <Mail size={16} /> Email Us
                </motion.a>
            </section>
        </div>
    );
};

export default Careers;
